/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Flickity from "flickity";
require("flickity-as-nav-for");

/*------------------------------------*\
    PRODUCT GALLERY
\*------------------------------------*/
class TruckGalleryNav {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.thumbCarousel = self.elem.querySelectorAll('[data-truck-gallery-carousel]');
    }

    init() {
        let self = this;

        self.initCarousel();
    }

    initCarousel() {
        let self = this;

        const flkty = new Flickity(self.thumbCarousel, {
            asNavFor: document.querySelector('.truck-gallery__carousel')[0],
            pageDots: false,
            //groupCells: true,
            contain: true,
            resize: false,
            prevNextButtons: true,
            verticalCells: true
        });
    }

}

export default TruckGalleryNav;